<mat-card class="transparent-card">
    <mat-card-header>
        <mat-card-title>Create Veto</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <form [formGroup]="vetoGroup" (ngSubmit)="createVeto()">
            <mat-form-field appearance="fill" [hideRequiredMarker]="true">
                <mat-label>Competition</mat-label>
                <mat-select [formControl]="vetoGroup.controls.competitionControl">
                    <mat-select-trigger>
                        <ng-container *ngIf="getSelectedCompetition(vetoGroup.controls.competitionControl.value) as competition">
                            <img class="select-field-logo" [src]="competition.logo || placeholderImage"> {{ competition.name }}
                        </ng-container>
                    </mat-select-trigger>
                    <ng-container *ngFor="let competition of competitions">
                        <mat-option [value]="competition.uid">
                            <img class="select-field-logo" [src]="competition.logo || placeholderImage"> {{ competition.name }}
                        </mat-option>
                    </ng-container>
                </mat-select>
            </mat-form-field>
            <mat-form-field class="teams-field" appearance="fill" [hideRequiredMarker]="true">
                <mat-label>Teams</mat-label>
                <mat-select [formControl]="vetoGroup.controls.teamsControl" multiple>
                    <mat-select-trigger>
                        <ng-container *ngIf="getSelectedTeams(vetoGroup.controls.teamsControl.value) as teams">
                            <ng-container *ngFor="let team of teams">
                                <ng-container *ngIf="teams.indexOf(team) > 0">
                                    ,
                                </ng-container>
                                <img class="select-field-logo" [src]="team.logo || placeholderTeamLogo"> {{ team.name }}
                            </ng-container>
                        </ng-container>
                    </mat-select-trigger>
                    <ng-container *ngFor="let team of teams">
                        <mat-option *ngIf="team.competition == vetoGroup.controls.competitionControl.value" [value]="team.uid">
                            <img class="select-field-logo" [src]="team.logo || placeholderTeamLogo"> {{ team.name }}
                        </mat-option>
                    </ng-container>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="fill" [hideRequiredMarker]="true">
                <mat-label>Format</mat-label>
                <mat-select [formControl]="vetoGroup.controls.formatControl">
                    <mat-option value="bo1">Best-of-1</mat-option>
                    <mat-option value="bo3">Best-of-3</mat-option>
                    <mat-option value="bo5">Best-of-5</mat-option>
                    <mat-option value="bo5Final">Best-of-5 | Double Ban</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="fill" [hideRequiredMarker]="true">
                <mat-label>Map Pool</mat-label>
                <mat-select [formControl]="vetoGroup.controls.mapPoolControl" multiple>
                    <mat-option value="Abyss">Abyss</mat-option>
                    <mat-option value="Ascent">Ascent</mat-option>
                    <mat-option value="Bind">Bind</mat-option>
                    <mat-option value="Breeze">Breeze</mat-option>
                    <mat-option value="Corrode">Corrode</mat-option>
                    <mat-option value="Fracture">Fracture</mat-option>
                    <mat-option value="Haven">Haven</mat-option>
                    <mat-option value="Icebox">Icebox</mat-option>
                    <mat-option value="Lotus">Lotus</mat-option>
                    <mat-option value="Pearl">Pearl</mat-option>
                    <mat-option value="Split">Split</mat-option>
                    <mat-option value="Summit">Summit</mat-option>
                    <mat-option value="Sunset">Sunset</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="fill" [hideRequiredMarker]="true">
                <mat-label>Date</mat-label>
                <input matInput [matDatepicker]="picker" (click)="picker.open()" [min]="minDate" [max]="maxDate" [formControl]="vetoGroup.controls.dateControl" >
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker disabled="false"></mat-datepicker>
            </mat-form-field>
            <mat-card-actions>
                <button class="create-button" mat-raised-button type="submit" *ngIf="!isProcessing" [disabled]="!vetoGroup.valid" color="primary"><mat-icon>add_box</mat-icon>Create</button>
                <button class="create-button" mat-raised-button type="submit" *ngIf="isProcessing" disabled><mat-spinner></mat-spinner></button>
            </mat-card-actions>
        </form>
    </mat-card-content>
</mat-card>